<mat-form-field
  class="form-chip-list"
  data-cy="customer-input">
  <mat-label>{{ ("agencies" | i18n) || "Vermittler" | titlecase }}</mat-label>
  <mat-chip-list
    #customerList
    [disabled]="!!(disabled$ | async)">
    <mat-chip
      *ngFor="let customer of selectedCustomers$ | async; let i = index"
      [attr.data-cy]="'selected-customer-' + customer.id">
      {{ customer.displayName }}
      <mat-icon
        matChipRemove
        *ngIf="!(disabled$ | async)"
        data-cy="remove-customer"
        svgIcon="close-circle"
        (click)="removeCustomer(customer.id)">
      </mat-icon>
    </mat-chip>

    <input
      ngModel
      name="customerInput"
      [disabled]="!!(disabled$ | async)"
      [matAutocomplete]="autoCustomers"
      [matChipInputFor]="customerList"
      (ngModelChange)="searchCustomer($event)"
      data-cy="customer-text-input" />
  </mat-chip-list>
  <mat-autocomplete
    #autoCustomers="matAutocomplete"
    (optionSelected)="selectedCustomer($event)">
    <mat-option
      *ngFor="
        let customer of filteredCustomers$ | async;
        trackBy: trackByCustomerId
      "
      [attr.data-cy]="'customer-option-' + customer.id"
      [value]="customer">
      {{ customer.displayName }}
    </mat-option>
  </mat-autocomplete>
  <mat-hint
    *ngIf="showHint$ | async"
    align="end">
    <ng-content select="[slot=hint]"></ng-content>
  </mat-hint>
</mat-form-field>
